export interface TokenDO {
    slug: string;
    name: string;
    ticker: string;
    data: TokenD
    sectors?: {
        name: string;
        slug: string;
    }[]
}

export interface TokenD {
    price: number;
    market_cap: number;
    market_cap_dominance: number;
    fully_diluted_market_cap: number;
    volume_24h: number;
    percent_change_24h: number;
    percent_change_7d: number;
    percent_change_30d: number;
    circulating_supply: number,
    cmc_rank: number,
    max_supply: number,
    total_supply: number,
}

export interface TokenData {
    price: string,
    percent_change_24h: string,
    market_cap: string,
    fully_diluted_market_cap: string,
    volume_24h: string,
    market_cap_dominance: string;
}

export const TokenMetricNames = {
    price: {
        french: 'Prix',
        english: 'Price'
    },
    percent_change_24h: {
        french: 'Evol. prix 24h',
        english: '24h Price Change'  
    },
    market_cap: {
        french: 'Cap. de marché',
        english: 'Market Cap'
    },
    fully_diluted_market_cap: {
        french: 'FDV',
        english: 'FDV'
    },
    volume_24h: {
        french: '24h volume',
        english: '24h Volume'
    },
    market_cap_dominance: {
        french: 'Dominance Cap. de marché',
        english: 'Mkt Cap Dominance'
    },
}

export enum MetricColor {
    neutral = 'var(--pacific)',
    positive = 'var(--green-percentage)',
    negative = 'var(--coral)'
}
